import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { gql } from '@apollo/client/core';
import { Query } from '@spectee/graphql/api';
import { listGroups } from '@spectee/graphql/queries';

const document = gql(listGroups);

type QueryResult = {
  listGroups: Query['listGroups'];
};

export function useListGroups() {
  const API = useQuery<QueryResult>(document);

  const listGroupsRes = computed(() => API.result.value?.listGroups ?? []);
  return {
    ...API,
    listGroupsRes,
  };
}
